import React from 'react';

import * as S from './styles';
import { Button, FieldsWrapper } from '../../components';
import HeadTitle from '../../components/HeadTitle';
import FooterWrapper from '../../components/FooterWrapper';
import { UnitCard } from './components/UnitCard';
import { UnitFilter } from '../../models/Specialist';

export type PatientFormPageProps = {
  units: UnitFilter[];
  onSubmit: () => void;
  goBack?: () => void;
  handleSelectedUnit?: (prop: UnitFilter) => void;
  disabledSubmitButton?: boolean;
  selectedUnit: string;
};

export function UnitsTemplate({
  units,
  onSubmit,
  goBack,
  handleSelectedUnit,
  disabledSubmitButton,
  selectedUnit
}: PatientFormPageProps) {
  const onSelectUnit = (unit: UnitFilter) => {
    handleSelectedUnit?.(unit);
  };

  return (
    <S.Container>
      <FieldsWrapper>
        <HeadTitle title="Selecione uma unidade" goBack={goBack} />
        <>
          {units.map(item => (
            <UnitCard
              key={item.unit_id}
              unit={item}
              isChecked={selectedUnit === item.unit_id}
              onUnitSelected={() => onSelectUnit(item)}
              showRadio
            />
          ))}
        </>
      </FieldsWrapper>
      <FooterWrapper>
        <S.ButtonWrapper>
          <Button title="Continuar" type="button" onClick={onSubmit} disabled={disabledSubmitButton} />
        </S.ButtonWrapper>
      </FooterWrapper>
    </S.Container>
  );
}
